module.exports = __webpack_public_path__ + "media/tokido.8346efb7.mp4";